import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { ReactSVG } from 'react-svg';

import { routesData } from '../../../../routes/routes';
import { isEmptyObject } from '../../../../utils/utils';

import ShopeeSvg from '../../../../assets/common/svg/shopee.svg';
import OrderSvg from '../../../../assets/common/svg/order.svg';
import WalletSvg from '../../../../assets/common/svg/wallet.svg';
import MailSvg from '../../../../assets/common/svg/mail.svg';
import MeSvg from '../../../../assets/common/svg/me.svg';

const svgMap = {
  'icon-dashboard': ShopeeSvg,
  'icon-order': OrderSvg,
  'icon-wallet': WalletSvg,
  'icon-now-ship': MailSvg,
  'icon-staff': MeSvg,
};

function SubMenuButton({ isActive, route }) {
  const classActive = isActive ? 'active' : '';
  return (
    <li className="nav-item" key={route.link}>
      <Link to={route.to} className={`nav-link-sub ${classActive}`}>
        <span className="title">{route.label}</span>
      </Link>
    </li>
  );
}

function MenuButton({
  route,
  isOpen = false,
  pathname,
  handleToggleOpenSubMenu,
}) {
  const { label, icon, path, to, children: subMenuRoute = [] } = route;
  const classOpen = isOpen ? 'active' : '';
  const classActive = pathname.startsWith(path) ? 'active active-link' : '';
  return (
    <li className={`nav-item ${classActive} ${classOpen}`}>
      <span
        className="nav-link"
        onClick={() => {
          if (subMenuRoute.length > 0) {
            handleToggleOpenSubMenu();
          }
        }}
      >
        <ReactSVG src={svgMap[icon]} className="icon" />
        {/* <i className={`icon ${icon}`} /> */}
        <Link to={to} className="title" onClick={e => e.stopPropagation()}>
          {label}
        </Link>
        {subMenuRoute.length > 0 && <span className="icon icon-arrow-thin" />}
      </span>
      {subMenuRoute.length > 0 && (
        <ul className="sub-menu">
          {subMenuRoute.map(subRoute => (
            <SubMenuButton
              key={subRoute.to}
              route={subRoute}
              isActive={subRoute.path === pathname}
            />
          ))}
        </ul>
      )}
    </li>
  );
}

class SidebarMenuItem extends React.Component {
  state = {
    isOpen: {},
  };

  handleToggleOpenSubMenu = path => {
    this.setState(prevState => ({
      isOpen: {
        ...prevState.isOpen,
        [path]: !prevState.isOpen[path],
      },
    }));
  };

  render() {
    const { isOpen } = this.state;
    const {
      authenticated,
      location,
      restaurants,
      merchantTableInfos,
      nowPortalMetadata,
    } = this.props;
    const { pathname } = location;
    return (
      authenticated && (
        <React.Fragment>
          {routesData.map(route => {
            let { children: subMenuRoute = [], to } = route;
            // Check role group

            if (
              isEmptyObject(restaurants) &&
              ['/order', '/ship', '/staff'].includes(route.path)
            ) {
              return null;
            }
            if (
              isEmptyObject(merchantTableInfos) &&
              ['/table'].includes(route.path)
            ) {
              return null;
            }
            if (
              isEmptyObject(nowPortalMetadata) &&
              isEmptyObject(restaurants) &&
              ['/merchant-wallet'].includes(route.path)
            ) {
              return null;
            }

            // Check sub role
            if (['/merchant-wallet'].includes(route.path)) {
              if (isEmptyObject(restaurants)) {
                subMenuRoute = subMenuRoute.filter(
                  subMenu =>
                    !['/merchant-wallet/wallet-management'].includes(
                      subMenu.path,
                    ),
                );
                to = '/merchant-wallet/history';
              }

              if (isEmptyObject(nowPortalMetadata)) {
                subMenuRoute = subMenuRoute.filter(
                  subMenu =>
                    ![
                      '/merchant-wallet/history',
                      '/merchant-wallet/withdraw',
                    ].includes(subMenu.path),
                );
              }
            }
            if(route.hide) {
              return null;
            }
            const newRoute = { ...route, to, children: subMenuRoute };

            return (
              <MenuButton
                key={route.path}
                route={newRoute}
                isOpen={isOpen[route.path] || false}
                pathname={pathname}
                handleToggleOpenSubMenu={() =>
                  this.handleToggleOpenSubMenu(route.path)
                }
              />
            );
          })}
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  restaurants: state.app.restaurants,
  merchantTableInfos: state.app.merchantTableInfos,
  nowPortalMetadata: state.app.nowPortalMetadata,
});

export default withRouter(connect(mapStateToProps)(SidebarMenuItem));



// WEBPACK FOOTER //
// ./foody/src/layout/components/SidebarMenu/components/SidebarMenuItem.jsx